<template lang="html">
  <div
    v-if="type == 'checkbox'"
    class="form-group form-check"
    :class="theClass"
  >
    <label class="form-label form-check-label">
      <input
        :disabled="disabled"
        type="checkbox"
        class="form-check-input"
        checked
        readonly="readonly"
      />
      <span>
        <img v-if="image" :src="image" />
        <i v-if="icon" :class="'icon-' + icon"></i>
        {{ label }}
      </span>
      <span v-if="textRight" class="float-right"
        ><small>{{ textRight }}</small></span
      >
      <span v-else class="float-right"
        ><a
          href="#"
          id="FacebookBtn"
          onclick="window.open('http://localhost:8080/oauth/authenticate/mercadolivre?callback=http://localhost:4000/%23/mercadolivre%3Fkey=', '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');"
          >Conectar</a
        ></span
      >
    </label>
  </div>
  <div
    v-else-if="type == 'checkbox2'"
    class="form-group form-check form-check-2"
    :class="theClass"
  >
    <label class="form-label form-check-label">
      <span class="label">
        <img v-if="image" :src="image" />
        <i v-if="icon" :class="'icon-' + icon"></i>
        <span v-html="label"></span>
      </span>
      <input :disabled="disabled" type="checkbox" class="form-check-input" />
      <span class="check"
        ><small>{{ textRight }}</small></span
      >
    </label>
  </div>
  <div
    v-else-if="type == 'checkbox-code'"
    class="form-group form-check"
    :class="theClass"
  >
    <label class="form-label form-check-label">
      <input :disabled="disabled" type="checkbox" class="form-check-input" />
      <span>
        <img v-if="image" :src="image" />
        <i v-if="icon" :class="'icon-' + icon"></i>
        {{ label }}
      </span>
      <span class="form-check-display"></span>
    </label>
    <div class="input-group mt-2">
      <input
        :disabled="disabled"
        type="text"
        class="form-control"
        :placeholder="placeholder"
      />
      <span class="input-group-btn">
        <button class="btn btn-primary px-3" type="button">Confirmar</button>
      </span>
    </div>
  </div>
  <div v-else-if="type == 'textarea'" class="form-group" :class="theClass">
    <label class="form-label" v-if="label">{{ label }}</label>
    <input :disabled="disabled" v-else type="text" :value="value" />
    <textarea
      class="form-control"
      :placeholder="placeholder"
      v-model="model"
      v-on:input="updateValue()"
      :class="formControlStatus"
      :rows="rows"
    ></textarea>
    <div class="invalid-feedback">{{ feedback }}</div>
  </div>
  <div
    v-else-if="type == 'text'"
    class="form-group"
    :class="theClass"
    :id="componentId"
  >
    <label class="form-label" v-if="label"
      >{{ label }} <strong v-if="strongLabel">{{ strongLabel }}</strong></label
    >

    <the-mask
      v-if="mask"
      v-model="model"
      class="form-control"
      :mask="mask"
      :placeholder="placeholder"
      v-on:input="updateValue()"
      :class="formControlStatus"
    ></the-mask>
    <money
      :disabled="disabled"
      v-else-if="money"
      v-model="model"
      v-bind="moneyData"
      class="form-control"
      :placeholder="placeholder"
      :class="formControlStatus"
      @input="updateValue"
    ></money>
    <input
      :disabled="disabled"
      v-else
      type="text"
      class="form-control"
      :placeholder="placeholder"
      v-model="model"
      v-on:input="updateValue()"
      :class="formControlStatus"
    />

    <div class="invalid-feedback">{{ feedback }}</div>
  </div>
  <div
    v-else-if="type == 'password'"
    class="form-group"
    :class="theClass"
    :id="componentId"
  >
    <label class="form-label" v-if="label"
      >{{ label }} <strong v-if="strongLabel">{{ strongLabel }}</strong></label
    >

    <input
      :disabled="disabled"
      type="password"
      class="form-control"
      :placeholder="placeholder"
      v-model="model"
      v-on:input="updateValue()"
      :class="formControlStatus"
    />

    <div class="invalid-feedback">{{ feedback }}</div>
  </div>
  <div v-else-if="type == 'number'" class="form-group" :class="theClass">
    <label class="form-label" v-if="label">{{ label }}</label>
    <input
      :disabled="disabled"
      type="number"
      :max="max"
      :min="min"
      class="form-control"
      :placeholder="placeholder"
      v-model="model"
      v-on:input="updateValue()"
    />
  </div>
  <div
    v-else-if="type == 'text-btn'"
    class="form-group"
    :class="formGroupStatus + ' ' + disabled"
  >
    <label class="form-label" v-if="label">{{ label }}</label>
    <div class="input-group">
      <input
        :disabled="disabled"
        v-if="readonly"
        type="text"
        v-model="inputValue"
        class="form-control"
        :placeholder="placeholder"
        readonly
      />
      <the-mask
        v-else-if="mask"
        v-model="inputValue"
        class="form-control"
        :mask="mask"
        :placeholder="placeholder"
        :class="formControlStatus"
      ></the-mask>
      <input
        :disabled="disabled"
        v-else
        type="text"
        v-model="inputValue"
        class="form-control"
        :placeholder="placeholder"
        v-on:keyup.enter="actionEnter"
        id="resetInput"
      />
      <span class="input-group-append">
        <button class="btn" :class="btntype" type="button" @click="actionClick">
          <i v-if="icon" :class="'micon-' + icon"></i> {{ btntext }}
        </button>
      </span>
    </div>
    <div class="input-group-feedback">
      {{ invalidMsg }}
    </div>
  </div>
  <div
    v-else-if="type == 'select'"
    class="form-group"
    :class="theClass"
    :id="componentId"
  >
    <label class="form-label" v-if="label" v-html="label"></label>
    <select
      class="form-control"
      v-model="model"
      v-on:change="updateSelectValue($event)"
      :class="formControlStatus"
    >
      <option v-for="item in list" :value="item.value" :key="item.value">{{
        item.label
      }}</option>
    </select>
    <small v-if="info" class="form-text text-muted">{{ info }}</small>
    <div class="invalid-feedback">{{ feedback }}</div>
  </div>
</template>

<script>
import jQuery from 'jquery/dist/jquery.js'

export default {
  props: {
    type: {
      type: String
    },
    max: Number,
    min: Number,
    rows: String,
    label: String,
    strongLabel: String,
    placeholder: String,
    list: Array,
    icon: String,
    image: String,
    btntype: String,
    btntext: String,
    textRight: String,
    value: String,
    mask: String,
    money: String,
    readonly: Boolean,
    formControlStatus: String,
    invalidMsg: String,
    info: String,
    model: Object,
    feedback: String,
    disabled: Boolean,
    moneyDecimals: Number,
    componentId: String
  },
  data () {
    return {
      inputValue: null,

      price: 123.45,
      moneyData: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    theClass () {
      if (this.disabled) {
        return 'disabled'
      }
    }
  },
  mounted () {
    if (this.moneyDecimals) {
      this.moneyData.precision = this.moneyDecimals
    }
  },
  watch: {
    value: function () {
      this.inputValue = this.value
    }
  },
  methods: {
    actionClick (event) {
      var targetId = event.currentTarget
      this.$emit(
        'inputactionclick',
        this.inputValue,
        jQuery(targetId)
          .closest('.input-group')
          .children('input')
      )
    },
    actionEnter (event) {
      var targetId = event.currentTarget
      this.$emit(
        'inputactionenter',
        this.inputValue,
        jQuery(targetId)
          .closest('.input-group')
          .children('input')
      )
    },
    updateValue () {
      this.$emit('updateValue', this.model)
    },
    updateSelectValue (event) {
      this.$emit(
        'updateValue',
        this.model,
        this.list[event.target.selectedIndex]
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variaveis.scss";
// @import "src/assets/utils.scss";
// @import "src/assets/scss/grid.scss";
.form-group {
  border: 0;
  padding: 0;
  margin: 0;
  & > label {
    margin: 0;
  }
  .btn {
    align-items: center;
    justify-content: center;
    display: flex;
    i {
      margin: 0 8px;
    }
  }
}
.form-check-label {
  padding: 0;
  display: block;

  img {
    width: 20px;
    height: auto;
    max-height: 20px;
    margin-top: -3px;
    margin-right: 5px;
  }
}
.input-group-feedback {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
.form-group {
  margin-bottom: -1px;
  background-color: #fff;
  /*border-top: 1px solid rgba(0, 0, 0, 0.125);*/
  /*padding: 10px 0;*/
}

.form-check-2 {
  .check {
    background: $secondary-color;
    float: right;
    width: 44px;
    height: 24px;
    border-radius: 20px;
    position: relative;
    small {
      position: absolute;
      width: 20px;
      height: 20px;
      background: red;
      border-radius: 50%;
      margin: 2px;
      transform: translateX(100%);
    }
  }
  .form-check-input:checked + .check {
    small {
      background-color: blue;
    }
  }
}
.form-check {
  .form-check-input {
    display: none;
  }
  .form-check-label {
    padding: 0;
    display: block;
    i {
      color: $primary-color;
      display: inline-block;
      width: 28px;
      text-align: center;
      height: 28px;
      line-height: 28px;
      border-radius: 4px;
      background: #f0f0f0;
      font-size: 20px;
      margin: -4px 6px -4px 0;
    }
    img {
      width: 20px;
      height: auto;
      max-height: 20px;
      margin-top: -3px;
      margin-right: 5px;
    }
  }
  .form-check-display {
    position: relative;
    float: right;
    background-color: #ddd;
    width: 48px;
    height: 22px;
    border-radius: 4px;
    overflow: hidden;
    transition: 0.3s;
    box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);

    &:before {
      content: " ";
      position: absolute;
      width: 20px;
      height: 18px;
      background-color: white;
      top: 2px;
      right: initial;
      bottom: 0;
      left: 2px;
      border-radius: 3px;
      transition: 0.3s;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
    }
  }

  .form-check-input:checked ~ .form-check-display {
    background-color: $secondary-color;

    &:before {
      margin-left: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partial/form/Input.vue